import type {
  IKeyholderDataWeb,
  IUpdateKeyholderBillingProfileBody,
} from '@/app-package';
import type { AxiosResponse } from 'axios';
import axios from 'axios';

// TODO: Remove this during KB-1169
const updateKeyholderBillingProfile = async ({
  billingProfile,
  resetPaymentStatus = false,
}: {
  billingProfile: IKeyholderDataWeb;
  resetPaymentStatus?: boolean;
}): Promise<IKeyholderDataWeb> => {
  const { data } = await axios.post<
    IKeyholderDataWeb,
    AxiosResponse<IKeyholderDataWeb>,
    IUpdateKeyholderBillingProfileBody
  >('/supra/billing_profile', { billingProfile, resetPaymentStatus });
  return data;
};

export default updateKeyholderBillingProfile;
